import { render, staticRenderFns } from "./GridArea.vue?vue&type=template&id=7fda348e&"
import script from "./GridArea.vue?vue&type=script&lang=js&"
export * from "./GridArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports